import axiosClient from "./axiosClient";

const bookingApi = {
    getBookingId: (startDate, endDate) => {
        return axiosClient.get("/api/bookings", {
            params: {
                "startDate": startDate,
                "endDate": endDate,
                "bookingCustomerGroupId": 16123
            },
        });
    },
    createBooking: (id) => axiosClient.post(`/api/bookings/createBooking/${id}`),
    UpdateQuestionNaire: (customerId, data) => axiosClient.patch(`/api/bookings/${customerId}`, {answers: data}),
}

export default bookingApi;